var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m21.727 9.7-6.189-6.19c-1.055-1.09-2.848-.316-2.848 1.197V7.52C7.837 7.66 2 8.61 2 14.623c0 2.567 1.336 4.712 3.411 6.083 1.301.88 3.024-.351 2.532-1.898-.844-2.743-.422-4.185 4.747-4.501v2.742c0 1.512 1.793 2.286 2.848 1.196l6.19-6.19a1.635 1.635 0 0 0 0-2.355m-7.349 7.35v-4.467c-5.802.036-9.776 1.16-8.018 6.717-1.266-.844-2.672-2.321-2.672-4.677 0-5.029 5.626-5.415 10.69-5.415V4.67l6.189 6.19z"
  })));
};
export default SvgShare;